import Yup from 'utils/validation';

export const sourcingInviteCandidateSmsSchema = Yup.object({
  customTemplatedMessage: Yup.string()
    .max(600, 'Reduce your message to 600 characters or less.')
    .required('Enter message.')
});

export type SourcingInviteCandidateSmsFormData = Yup.InferType<
  typeof sourcingInviteCandidateSmsSchema
>;

export const sourcingInviteCandidateEmailSchema = Yup.object({
  customTemplatedMessage: Yup.string().required('Enter message.')
});

export type SourcingInviteCandidateEmailFormData = Yup.InferType<
  typeof sourcingInviteCandidateEmailSchema
>;
